import React from "react";
import './topBox.css';
import { store } from "../../redux/store";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import axios from "axios";
import { setBusinessName, setRetailerBlance, setRetailerBlanceShow } from "../../redux/misc-data/misc-data.action";
import tokenErrorHandler from "../tokenErrorHandler";
const httpClient = axios.create();
class HeaderAgentDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNo: this.props.phone,
            retailerBalance:'Loading',
        }
    }


    componentDidMount() {
        this.loadRetailerBalance()
        setTimeout(() => {
            if (this.props.consumerProfile != undefined &&
                this.props.consumerProfile != null &&
                this.props.consumerProfile != "") {
                var businessInfo = this.props.consumerProfile.businessInfo;
                if (businessInfo != undefined &&
                    businessInfo != null &&
                    businessInfo != "") {
                    var name = businessInfo.name;
                    store.dispatch(setBusinessName(name))
                }
    
            }
        }, 1000);

       
    }
    componentWillUnmount() {
    }

   loadRetailerBalance = () => {


        var url = '/api/v1/account/balance/';
        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo,
            'role': this.props.clientRole
        }

        httpClient.get(url + this.props.agentInfo, { headers }
        ).then((response) => {
          
            if (response.data.response.success == true) {
                var retailerBalanceVal = response.data.balance + response.data.creditLimit -
                    response.data.lien;
                this.setState({
                    retailerBalance: retailerBalanceVal
                })
                store.dispatch(setRetailerBlance(retailerBalanceVal))
                //store.dispatch(setRetailerBalanceVal(retailerBalanceVal));

            }

        }).catch(error => {


            if (error.message.includes("401")) {
                tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
            }


        });
    }


    render() {
        // alert(JSON.stringify(this.props.consumerProfile));
        return (

            <div class="col-12 col-md-6 col-lg order-lg-2">
                <div class="card">
                    {this.props.businessName != undefined &&
                        this.props.businessName != null &&
                        this.props.businessName != "" &&
                        <div class="top-box">
                            <Link to="/manage-payment" class="lbbtn">Load Fund</Link>
                            <i class="ta"></i>
                            <p>{this.props.businessName}</p>
                            <h5>{this.state.retailerBalance}</h5>
                        </div>
                    }
                    <div class="more-box">
                        {/* <p>Cashback: <span class="float-end active">₹ dummy</span></p> */}
                    </div>
                </div>
            </div>

        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage, },
        miscReduce: { phone, consumerProfile,businessName,
        agentInfo,clientRole,token} }
) => ({
    errorMessage, phone, consumerProfile,businessName,
    agentInfo,clientRole,token
});

export default connect(mapStateToProps, null)(HeaderAgentDetails);
